import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogContent, Icon } from "@sagot/ui";

const K = "deployKnowledge.widgetStudio.publishChoice";

export type PublishScope = "both" | "widget";

/** Stable ref callback: Radix would focus the header's close button first; start on the main choice instead. */
const focusOnMount = (element: HTMLButtonElement | null) => {
  element?.focus();
};

interface PublishChoiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onChoose: (scope: PublishScope) => void;
  /** The scope currently being published (shows a spinner on that button and locks both). */
  pending: PublishScope | null;
}

/** Asked when publishing the widget of a draft agent: the widget stays dark until the agent is live. */
export function PublishChoiceDialog({ open, onOpenChange, onChoose, pending }: PublishChoiceDialogProps) {
  const { t } = useTranslation();
  const busy = pending !== null;
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!busy) onOpenChange(next); }}>
      <DialogContent
        title={t(`${K}.title`)}
        description={t(`${K}.description`)}
        closeLabel={t("common.close")}
        className="max-w-md"
        footer={
          <>
            <Button variant="secondary" disabled={busy} loading={pending === "widget"} onClick={() => { onChoose("widget"); }}>
              {t(`${K}.widgetOnly`)}
            </Button>
            <Button ref={focusOnMount} disabled={busy} loading={pending === "both"} onClick={() => { onChoose("both"); }}>
              <Icon name="upload-cloud" />
              {t(`${K}.both`)}
            </Button>
          </>
        }
      />
    </Dialog>
  );
}
